



























































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import VLazyImage from 'v-lazy-image';
import SearchingPanel from '@/components/SearchingPanel';
import List2x2 from '@/components/List2x2';
import BannerWithSlot from '@/components/BannerWithSlot';
import Title from '@/components/Title';
import {RentersTranslations} from '@/types';
import {objectToQuerystring} from '@/services/api';

@Component({
  name: 'HowItWorks',
  components: {
    BannerWithSlot, List2x2,
    SearchingPanel, Title, VLazyImage,
  },
  data() {
    return {
      slide: 0,
      actualQuery: {},
    };
  },
  computed: {
    ...mapGetters( 'renters', ['translations']),
    ...mapGetters(['chooseButtonLink', 'searchingPanel', 'searchingPanelState']),
    translationHowItWorks() {
      return (this.translations as RentersTranslations).howItWorks;
    },

    whyUsBlock() {
      return !!this.translationHowItWorks && this.translationHowItWorks.whyUsBlock;
    },

    getImage() {
      return this.translationHowItWorks.slides.slides[0]?.image;
    },

    srcImg: {
      get() {
        return this.whyUsBlock.image && `${this.whyUsBlock.image[3600]}` || '';
      },
    },

    srcImgPlaceholder: {
      get() {
        return this.whyUsBlock.image && `${this.whyUsBlock.image[400]}`;
      },
    },

    srcSet: {
      get() {
        return this.whyUsBlock.image &&
                `${this.whyUsBlock.image[400]} 400w,
                ${this.whyUsBlock.image[800]} 800w,
                ${this.whyUsBlock.image[1300]} 1300w,
                ${this.whyUsBlock.image[1900]} 1900w,
                ${this.whyUsBlock.image[3600]} 3600w`;
      },
    },
  },
  methods: {
    ...mapActions(['updateActualSearchData']),
    sendToApiSearch(data) {
      this.$set(this, 'actualQuery', {...this.actualQuery, ...data});
      this.updateActualSearchData(this.actualQuery);
      this.$router.push({path: `/catalog/?${objectToQuerystring(this.actualQuery)}`});
    },
  },
})
export default class HowItWorks extends Vue {}
